import { render, staticRenderFns } from "./_AddCustomExpenseDialog.vue?vue&type=template&id=124a0f34"
import script from "./_AddCustomExpenseDialog.vue?vue&type=script&lang=js"
export * from "./_AddCustomExpenseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports